import { writeAppNavigationState, DEFAULT_PROPERTY_NAVIGATION_STATE } from './appNavigationState';

/** Scalar navigation inputs; this never reimplements inventory matching. */
export function overviewNavigationUrl(href:string,filter:string,medianRent?:number|null) {
  const url=new URL(writeAppNavigationState(href,{properties:{...DEFAULT_PROPERTY_NAVIGATION_STATE,flags:filter==='specials'?['specials']:[],selectedPropertyId:null}}));
  url.searchParams.delete('overviewAvailable');
  url.searchParams.delete('overviewMaxRent');
  if(filter==='available') url.searchParams.set('overviewAvailable','true');
  if(filter==='median' && medianRent && Number.isFinite(medianRent)) url.searchParams.set('overviewMaxRent',String(medianRent));
  return url.toString();
}
